import { Download, Share, Smartphone } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ANDROID_STEPS = [
  "Buka menu browser (ikon tiga titik) di Chrome.",
  "Pilih Instal aplikasi atau Tambahkan ke layar utama.",
  "Konfirmasi Instal agar ikon Iya Lagi Manjat muncul di layar utama.",
];

const IPHONE_STEPS = [
  "Buka situs ini melalui Safari.",
  "Ketuk tombol Bagikan di bawah layar Safari.",
  "Pilih Tambah ke Layar Utama, lalu buka aplikasinya dari ikon baru.",
];

function Steps({ items, testId }) {
  return (
    <ol className="space-y-3" data-testid={testId}>
      {items.map((item, index) => (
        <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#1A3323]/85">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E3EDD9] text-xs font-extrabold text-[#1A3323]">
            {index + 1}
          </span>
          <span>{item}</span>
        </li>
      ))}
    </ol>
  );
}

export function InstallGuide() {
  return (
    <section className="overflow-hidden rounded-[18px] bg-white ring-1 ring-[#1A3323]/10" data-testid="install-guide">
      <Accordion type="single" collapsible className="px-4" data-testid="install-guide-accordion">
        <AccordionItem value="install-app" className="border-b-0">
          <AccordionTrigger className="py-4 no-underline hover:no-underline" data-testid="install-guide-trigger">
            <span className="flex items-center gap-3 text-left">
              <Download className="h-5 w-5 shrink-0 text-[#3D6F4B]" />
              <span>
                <span className="block font-bold text-[#1A3323]" data-testid="install-guide-heading">Add to Home Screen</span>
                <span className="block text-xs font-normal text-muted-foreground">Pasang aplikasi di layar utama HP</span>
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-4">
            <div className="space-y-4">
              <div className="border-l-4 border-[#3D6F4B] bg-[#F5F3EB] p-4" data-testid="install-guide-android">
                <div className="mb-3 flex items-center gap-2 font-extrabold text-[#1A3323]">
                  <Smartphone className="h-4 w-4" />
                  Android (Chrome)
                </div>
                <Steps items={ANDROID_STEPS} testId="install-guide-android-steps" />
              </div>
              <div className="border-l-4 border-[#7C9A6E] bg-[#F5F3EB] p-4" data-testid="install-guide-iphone">
                <div className="mb-3 flex items-center gap-2 font-extrabold text-[#1A3323]">
                  <Share className="h-4 w-4" />
                  iPhone (Safari)
                </div>
                <Steps items={IPHONE_STEPS} testId="install-guide-iphone-steps" />
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
}
